import React, {Component} from "react";
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown'

const SelectWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    
    select {
        width: 100%;
        height: 100%;
    }
`;

class FormattedSelect extends Component {
    state = {
        value: null,
    };

    constructor(props) {
        super(props);

        if (props.value) {
            this.state.value = props.value;    
        } else {
            this.state.value = props.items[0].Value;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            });
        }
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    };

    render() {
        const {value} = this.state;
        const {id, name, items} = this.props;
        
        const selectedItem = items.find(item => item.Value === value.toString());
        
        return <div className="form-control d-flex align-items-center justify-content-between">
            {selectedItem && <div>
                {selectedItem.Text}
            </div>}
            <FontAwesomeIcon icon={faCaretDown} className="text-primary ml-2" />
            <SelectWrapper>
                <select id={id} name={name} value={value} onChange={this.onChange}>
                    {
                        items.map(item => <option value={item.Value} key={item.Value}>
                            {item.Text}
                        </option>)
                    }
                </select>
            </SelectWrapper>
        </div>
    }
}

export default FormattedSelect;
